<script setup>
import DateTimeHelper from "@/common/DateTimeHelper";
import { HUMANLY_MAIN_APP_URL } from "@/common/Env";
const emit = defineEmits(["closed"]);
const { event } = defineProps({
  event: {
    type: Object,
    required: true,
    default: () => ({}),
  },
});

function meetingUrl(uuid) {
  const url = `${HUMANLY_MAIN_APP_URL}/meetings?event_id=${uuid}`;
  return url;
}

function onClose() {
  emit("closed");
}
</script>

<template>
  <div id="event-registration">
    <div class="d-flex align-items-center justify-content-between">
      <div>
        <div>
          <a v-if="event.id" :href="meetingUrl(event.id)" target="_blank" rel="noopener noreferrer">
            <b>{{ event.title }}</b>
          </a>
          <b v-else>{{ event.title }}</b>
        </div>
        <div v-if="event.statusAtAgo" class="text-color-black-50">{{ event.statusAtAgo }}</div>
      </div>

      <span class="material-icons-round text-color-black-50 md-18 close-touchpoint" @click="onClose">
        close
      </span>
    </div>

    <div class="card-container mt-16">
      <div v-if="event.statusLabel" class="d-flex justify-content-between mb-8">
        <span class="field">Status</span>
        <span class="field-description" :class="'status-' + event.status">{{ event.statusLabel }}</span>
      </div>
      <div v-if="event.start_time" class="d-flex justify-content-between mb-8">
        <span class="field">Start</span>
        <span class="field-description">{{ DateTimeHelper.exactDateTimeInTimezone(event.start_time) }}</span>
      </div>
      <div v-if="event.end_time" class="d-flex justify-content-between mb-8">
        <span class="field">End</span>
        <span class="field-description">{{ DateTimeHelper.exactDateTimeInTimezone(event.end_time) }}</span>
      </div>
      <div v-if="event.registered_at" class="d-flex justify-content-between">
        <span class="field">Registered</span>
        <span class="field-description">{{ DateTimeHelper.exactDateTimeInTimezone(event.registered_at) }}</span>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.card-container {
  background-color: $black-5;
  padding: 12px;
  border-radius: $tf-global-border-radius;
}

.field {
  color: $black-50;
}

.field-description {
  font-weight: 500;
}

.status-confirmed {
  color: $green-100;
}

.status-pending {
  color: $tf-sourced-stopped-color;
}

.status-declined {
  color: $black-50;
}

.close-touchpoint {
  cursor: pointer;
}
</style>
